<section>
	<ng-container *ngIf="!isDataLoading">
		<ng-container *ngIf="validDocArray.length; else noDoc">
			<section class="margin-standard">
				<p dcrHTMLKey="ADDITIONAL_RESOURCES_TITLE">Additional resources to help you and your client make the best decision for their portfolio</p>
			</section>
			<section>
				<section class="row align-items-top margin-standard">
					<section *ngFor="let docElem of validDocArray" class="col-24">
						<a
							class="margin-standard d-flex align-items-center"
							[href]="docElem.link"
							target="_blank"
							[attr.data-link-event]="'additional resources:' + docElem.label | analyticEventEvaluatorPipe"
						>
							<div>
								<span class="download-icon"><icon [type]="docElem.iconType"></icon></span>
							</div>
							<div class="padding-left-20">
								<div class="text-20-bold">{{ docElem.label }}</div>
								<div [dcrHTMLKey]="docElem.materialType + '_DESCRIPTION' | uppercase"></div>
							</div>
						</a>
					</section>
				</section>
			</section>

			<ac-disclosure [isExpandable]="false"><span dcrHTMLKey="ADDITIONAL_RESOURCES_DISCLOSURE">ADDITIONAL_RESOURCES_DISCLOSURE</span></ac-disclosure>
		</ng-container>
		<ng-template #noDoc>
			<section class="margin-standard" dcrHTMLKey="NO_FILE_FOUND_ERROR_TEXT">No documents found</section>
		</ng-template>
		<ac-cta-link
			*ngIf="brandAndShareLink"
			class="margin-bottom-20 text-16-bold"
			[link]="brandAndShareLink"
			icon="arrow-right"
			[track-event]="'models-experience:additional-resources:brand-share-link'"
		>
			<span dcrHTMLKey="BRAND_SHARE_LABEL">BRAND AND SHARE TOOL</span>
		</ac-cta-link>
	</ng-container>
</section>
